var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPadIcon = function SvgPadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 2.25,
    fill: "#fff",
    stroke: "#DFDFDF",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.174 3.02a.768.768 0 0 0-.34 0 .967.967 0 0 0-.3.135l-.013.009L7.941 5.4a.532.532 0 0 0 .282.983h7.561a.531.531 0 0 0 .282-.983l-3.58-2.237-.014-.009a.967.967 0 0 0-.298-.136ZM9.7 7.27a.532.532 0 0 0-1.064 0v3.78a.532.532 0 0 0 1.064 0V7.27ZM11.59 7.27a.532.532 0 1 0-1.063 0v3.78a.532.532 0 1 0 1.063 0V7.27ZM13.48 7.27a.532.532 0 0 0-1.063 0v3.78a.532.532 0 0 0 1.063 0V7.27ZM15.37 7.27a.532.532 0 0 0-1.063 0v3.78a.532.532 0 1 0 1.064 0V7.27ZM7.75 11.937a.532.532 0 1 0 0 1.063h8.507a.532.532 0 0 0 0-1.063H7.75Z",
    fill: "#6E6E6E"
  })));
};

export default SvgPadIcon;